import type { InsightsAdvancedTypes } from "@/redux/insightsAdvanced/insightAdvanceTypes";

export const insightAdvancedReducer = {
  resetInsightAdvancedFetching: (state: InsightsAdvancedTypes) => {
    state.fetching = false;
  },
  resetInsightAdvancedError: (state: InsightsAdvancedTypes) => {
    state.error = null;
  },

  resetInsightAdvancedSuccess: (state: InsightsAdvancedTypes) => {
    state.success = null;
  },
  resetInsightAdvancedListData: (state: InsightsAdvancedTypes) => {
    state.insightsAdvancedListData = [];
  },
  resetProfiltLossData: (state: InsightsAdvancedTypes) => {
    state.profitLossData = [];
  },
  resetTotelSales: (state: InsightsAdvancedTypes) => {
    state.totelSales = [];
  },
  resetTotalExpenses: (state: InsightsAdvancedTypes) => {
    state.totelExpense = [];
  },
};
